import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import moment from 'moment';
import cn from 'classnames';
import { useAction } from 'hooks';
import { CalendarBtn } from 'components/DatePickers';
import App from 'modules/App';
const DateInput = ({ id, momentDate, disabled, isDisabled = false, onChange })=>{
    const locale = useSelector(App.selectors.locale);
    const openDropdown = useAction(App.actions.openDropdown, `${id}PopUp`);
    const [value, setValue] = useState('');
    const intl = useIntl();
    useEffect(()=>{
        setValue(momentDate ? momentDate.clone().locale(locale).format('L') : '');
    }, [
        locale,
        momentDate
    ]);
    const label = intl.formatMessage(App.messages.labels.date);
    const onDateChange = (evt)=>{
        setValue(evt.target.value);
        if (!evt.target.value) return;
        const newMomentDate = moment.utc(evt.target.value, 'L');
        const isValid = newMomentDate.isValid();
        if (!isValid) return;
        const isAfterDisabled = !disabled || !disabled.before || newMomentDate.isSameOrAfter(disabled.before);
        if (!isAfterDisabled) return;
        const isBeforeDisabled = !disabled || !disabled.after || newMomentDate.isSameOrBefore(disabled.after);
        if (!isBeforeDisabled) return;
        onChange(newMomentDate);
    };
    const onClick = (evt)=>{
        evt.stopPropagation();
    };
    const onFocus = ()=>{
        openDropdown();
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('SingleDatePickerInput SingleDatePickerInput__withBorder d-flex align-items-center', {
            SingleDatePickerInput__disabled: isDisabled
        }),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: cn('DateInput', {
                    DateInput__disabled: isDisabled
                }),
                children: /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    id: id,
                    name: id,
                    className: cn('DateInput_input', {
                        DateInput_input__disabled: isDisabled
                    }),
                    "aria-label": label,
                    placeholder: label,
                    autoComplete: "off",
                    value: value,
                    disabled: isDisabled,
                    onClick: onClick,
                    onFocus: onFocus,
                    onChange: onDateChange
                })
            }),
            /*#__PURE__*/ _jsx(CalendarBtn, {
                popUpName: `${id}PopUp`,
                className: "ml-0 pl-0 pt-2",
                isDisabled: isDisabled
            })
        ]
    });
};
export default DateInput;
